import { useMemo } from 'react';
import { ApiCall } from '@/stores/apiDebugStore';
import { ConsoleEntry } from '@/stores/consoleDebugStore';

export type ApiFilterType = 'all' | 'success' | 'error';
export type ConsoleFilterType = 'all' | 'error' | 'warn';

export const useFilteredApiCalls = (
  calls: ApiCall[],
  searchTerm: string,
  filterType: ApiFilterType
) => {
  return useMemo(() => {
    return calls.filter((call) => {
      // Search filtering
      const matchesSearch = 
        !searchTerm ||
        call.url.toLowerCase().includes(searchTerm.toLowerCase()) ||
        call.method.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (call.status?.toString() || '').includes(searchTerm);

      // Status filtering
      const matchesFilter = 
        filterType === 'all' ||
        (filterType === 'success' && call.status && call.status >= 200 && call.status < 300) ||
        (filterType === 'error' && ((call.status && call.status >= 400) || call.error));

      return matchesSearch && matchesFilter;
    });
  }, [calls, searchTerm, filterType]);
};

export const useFilteredConsoleEntries = (
  entries: ConsoleEntry[],
  searchTerm: string,
  filterType: ConsoleFilterType
) => {
  return useMemo(() => {
    return entries.filter((entry) => {
      // Search filtering
      const matchesSearch = 
        !searchTerm ||
        entry.message.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (entry.source?.toLowerCase() || '').includes(searchTerm.toLowerCase());

      // Level filtering
      const matchesFilter = 
        filterType === 'all' ||
        entry.level === filterType;

      return matchesSearch && matchesFilter;
    });
  }, [entries, searchTerm, filterType]);
};